import { render, staticRenderFns } from "./InputPostCode.vue?vue&type=template&id=fcdb7ac8&"
import script from "./InputPostCode.vue?vue&type=script&lang=js&"
export * from "./InputPostCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports